import { render, staticRenderFns } from "./CompRanksCard.vue?vue&type=template&id=3ffdd4be&scoped=true&"
import script from "./CompRanksCard.vue?vue&type=script&lang=js&"
export * from "./CompRanksCard.vue?vue&type=script&lang=js&"
import style0 from "./CompRanksCard.vue?vue&type=style&index=0&id=3ffdd4be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffdd4be",
  null
  
)

export default component.exports